export const ROLES = {
  PLAYER: "player",
  COACH: "coach",
  ADMIN: "admin",
};

export const PLANS = {
  FREE: "Free",
  PRO: "Pro",
  PREMIUM: "Premium",
};

export const PLAN_RANK = {
  [PLANS.FREE]: 0,
  [PLANS.PRO]: 1,
  [PLANS.PREMIUM]: 2,
};